import React from "react";
import EAAlert from "../../shared/EAAlert";
import { useTranslation } from "react-i18next";
import EASkeletonLoader from "../../shared/EASkeletonLoader";
import SingleFutureTicket from "./SingleFutureTicket";
import useFutureTickets from "./hooks/useFutureTickets";

const FutureTickets: React.FC = () => {
  const { t } = useTranslation();
  const { tickets, loading, refreshTickets } = useFutureTickets();

  if (loading) {
    return <EASkeletonLoader height="120px" />;
  }

  if (tickets.length <= 0) {
    return <EAAlert type="warning" message={t("brak_biletow")} />;
  }

  return (
    <>
      {tickets.map((ticket, index) => (
        <SingleFutureTicket ticket={ticket} key={index} onRefreshTickets={refreshTickets} />
      ))}
    </>
  );
};

export default FutureTickets;
